// translates the activeComponentId into an int

export const getStepperActiveIndex = (componentsState) => {
  return componentsState.array.findIndex((component) => component._id === componentsState.activeId);
};
